import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import bike from './bike.svg';
import { primaryColor, primaryColorBlue } from '../utility/constant';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        paddingBottom: 30,
        background: `linear-gradient(180deg, ${primaryColor} 0%, ${primaryColorBlue} 100%)`,
      }}
      className="rounded-b-[60px] pt-[110px]"
    >
      <div className="t:flex container px-5 justify-between items-center l:py-0 mx-auto">
        {/* Left Content */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex flex-col gap-6 w-full"
        >
          <h1 className="2xl:text-[40px] d:text-[30px] text-[25px] font-semibold text-white leading-[50px]">
            The Ultimate Solution for Streamlined Route Management and Billing
          </h1>

          <p className="text-gray-200 d:text-[16px] text-[14px] max-w-[650px] leading-relaxed">
            Say goodbye to manual invoicing and scattered records.{' '}
            <b>routeBilling</b>
            is your all-in-one web application designed to simplify and
            supercharge your route management, billing, and inventory
            operations. Empower your team to work smarter, faster, and with
            complete accuracy.
          </p>

          <div className="flex flex-wrap gap-3 mt-2">
            {/* Primary Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate('/auth/signup')}
              className="bg-[#4d5be5] text-white font-semibold px-10 w-[250px] py-3 rounded-full text-[16px] shadow-md border border-[#4d5be5] transition-all duration-300 hover:shadow-lg hover:bg-[#3c4ad8]"
            >
              GET STARTED
            </motion.button>
            {window.innerWidth < 600 && (
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => navigate('/auth/login')}
                className="bg-[#4d5be5] text-white font-semibold px-10 w-[250px] py-3 rounded-full text-[16px] shadow-md border border-[#4d5be5] transition-all duration-300 hover:shadow-lg hover:bg-[#3c4ad8]"
              >
                LOGIN
              </motion.button>
            )}
             {window.innerWidth < 600 && (
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => window.location.href = `https://shopkeeper.routebilling.online`}
            
                className="bg-[#4d5be5] text-white font-semibold px-10 w-[250px] py-3 rounded-full text-[16px] shadow-md border border-[#4d5be5] transition-all duration-300 hover:shadow-lg hover:bg-[#3c4ad8]"
              >
                SHOPKEEPER LOGIN
              </motion.button>
            )}

            {/* Secondary Button */}
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ width: 'calc(100% - 50px)' }}
          className="w-full t:flex justify-end py-10 l:py-0 overflow-hidden"
        >
          <img src={bike} alt="POS Illustration" width={'100%'} />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HeroSection;
